import { useEffect } from 'react';

import { useTourV2 } from './TourProvider';
import { PageTourArgs } from './types';

type TourConfigProps = {
  tourKey: string;
  steps: PageTourArgs[];
  onComplete?: () => void;
};

export const TourConfig = ({ tourKey, steps, onComplete }: TourConfigProps) => {
  const { api } = useTourV2();

  useEffect(() => {
    api.setConfig({ tourKey, steps, onComplete });
  }, [api, tourKey, steps, onComplete]);

  return null;
};
